import React, { useEffect, useState } from "react";
import "../admin/style.css";
import { toast } from "react-toastify";
import {
  deleteData,
  getData,
  postDataNoData,
  putDataNoToken,
} from "../../api/method";
import TableProduct from "../../components/admin/Product/table";
import ModalAdd from "../../components/admin/Product/add";
import ModalDelete from "../../components/admin/ModalConfirm";
import ModalEdit from "../../components/admin/Product/edit";

function Product(args) {
  const [openAdd, setOpenAdd] = useState(false);

  const toggleAdd = () => setOpenAdd(!openAdd);

  const closeBtnAdd = (
    <button className="close" onClick={toggleAdd}>
      &times;
    </button>
  );

  const [openEdit, setOpenEdit] = useState(false);

  const toggleEdit = () => setOpenEdit(!openEdit);

  const closeBtnEdit = (
    <button className="close" onClick={toggleEdit}>
      &times;
    </button>
  );

  const [openDel, setOpenDel] = useState(false);

  const toggleDel = () => setOpenDel(!openDel);

  const closeBtnDel = (
    <button className="close" onClick={toggleDel}>
      &times;
    </button>
  );

  const [dataBrand, setDataBrand] = useState([]);
  const [dataCategory, setDataCategory] = useState([]);
  const [error, setError] = useState({});
  const [data, setData] = useState({
    name: "",
    description: "",
    files: "",
    price: 0,
    discount: 0,
    quantity: 0,
    status: 1,
    dimension: 0,
    brandId: "",
    categoryId: "",
  });

  const onChangeValue = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const validation = (e) => {
    const msg = {};

    if (data.name === "") {
      msg.name = "Name is requied!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const getCategory = async () => {
    try {
      const result = await getData("/api/Category");
      setDataCategory(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getBrand = async () => {
    try {
      const result = await getData("/api/Brand");
      setDataBrand(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategory();
    getBrand();
  }, []);

  var selectedFile = null;
  const setSelectedFile = (e) => {
    getBase64(e.target.files[0]);
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      selectedFile = reader.result;
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleSubmitAdd = async () => {
    const isValid = validation();
    const productFormData = new Object();

    console.log(productFormData);
    if (selectedFile == null) {
      selectedFile = await toBase64(document.getElementById("files").files[0]);
    }

    if (isValid) {
      selectedFile = selectedFile.split("base64,")[1];

      try {
        const res = await postDataNoData("/api/Product", {
          base64Str: selectedFile,
          product: {
            name: data.name,
            description: data.description,
            image: data.files,
            price: data.price || 0,
            discount: data.discount || 0,
            quantity: data.quantity || 0,
            status: 1,
            soldQuantity: 0,
            dimension: data.dimension,
            brandId: data.brandId || 0,
            categoryId: data.categoryId || 0,
          },
        });
        toast.success("Add success!");
        setOpenAdd(false);
      } catch (err) {
        console.log(err);
        toast.error("Add fail!");
      }
    }
  };

  const [dataDel, setDataDel] = useState([]);

  const getProductByDel = async (id) => {
    try {
      const result = await getData(`/api/Product/${id}`);
      setDataDel(result.data);
      setOpenDel(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitDel = async (id) => {
    try {
      const res = await deleteData(`/api/Product/${id}`);
      if (res.status === 200) {
        setOpenDel(false);
        toast.success("Delete success!");
      }
    } catch (err) {
      console.log(err);
      setOpenDel(false);
      toast.error("Products have been ordered!");
    }
  };

  const [dataEdit, setDataEdit] = useState([]);

  const getProductByEdit = async (id) => {
    try {
      const result = await getData(`/api/Product/${id}`);
      setDataEdit(result.data);
      setData(result.data);
      setOpenEdit(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitEdit = async (id) => {
    const isValid = validation();
    const productFormDataEdit = new Object();
    console.log(productFormDataEdit);

    if (selectedFile == null) {
      selectedFile = await toBase64(document.getElementById("files").files[0]);
    }

    if (isValid) {
      selectedFile = selectedFile.split("base64,")[1];

      try {
        const res = await putDataNoToken(`/api/Product/${id}`, {
          base64Str: selectedFile,
          product: {
            id: data.id,
            name: data.name,
            description: data.description,
            image: data.image,
            price: data.price,
            discount: data.discount,
            quantity: data.quantity,
            status: 1,
            soldQuantity: data.soldQuantity,
            dimension: data.dimension,
            brandId: data.brandId,
            categoryId: data.categoryId,
          },
        });
        setOpenEdit(false);
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <div className="w-100 pt-4 px-5 py-5">
      <TableProduct
        toggleAdd={toggleAdd}
        getProductByDel={(id) => getProductByDel(id)}
        getProductByEdit={(id) => getProductByEdit(id)}
      />

      <ModalAdd
        isOpen={openAdd}
        toggle={toggleAdd}
        close={closeBtnAdd}
        onChange={onChangeValue}
        onKeyUp={handleKeyUp}
        onClick={() => handleSubmitAdd()}
        dataBrand={dataBrand}
        dataCategory={dataCategory}
        error={error}
      />

      <ModalEdit
        isOpen={openEdit}
        toggle={toggleEdit}
        close={closeBtnEdit}
        onChange={onChangeValue}
        onKeyUp={handleKeyUp}
        onClick={() => handleSubmitEdit(dataEdit.id)}
        dataBrand={dataBrand}
        dataCategory={dataCategory}
        dataEdit={dataEdit}
        error={error}
      />

      <ModalDelete
        title="Delete"
        text="Are you sure you want to delete the product?"
        toggle={toggleDel}
        close={closeBtnDel}
        isOpen={openDel}
        onClick={() => handleSubmitDel(dataDel.id)}
      />
    </div>
  );
}

export default Product;
